export default __webpack_public_path__ + "static/media/DSCN6151 (1).4760f91b.jpg";